import PropTypes from 'prop-types'
import { Alert, IconButton, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import { useLocale } from '../../../i18n/LocaleProvider'

import styles from './styles'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const IMPORTANT_ALERT_MESSAGES = {
  es: process.env.REACT_APP_SHOW_IMPORTANT_ALERT_ES,
  en: process.env.REACT_APP_SHOW_IMPORTANT_ALERT_EN,
  pt: process.env.REACT_APP_SHOW_IMPORTANT_ALERT_PT,
}

const ImportantAlertView = ({ onClose, noFixed }) => {
  const t = useTranslations()
  const { locale } = useLocale()

  const message =
    IMPORTANT_ALERT_MESSAGES[locale] || IMPORTANT_ALERT_MESSAGES.es

  return (
    <Alert
      severity="warning"
      sx={{
        ...styles.alert,
        ...(!noFixed ? styles.alertWarning : {}),
        maxWidth: noFixed ? 'none' : '400'
      }}
      action={
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={() => {
            onClose()
          }}
        >
          <X />
        </IconButton>
      }
    >
      <Typography component="p" variant="body2">
        <strong>{t('noun:important')}</strong>
      </Typography>
      <Typography component="p" variant="body2">
        {message}
      </Typography>
    </Alert>
  )
}

ImportantAlertView.propTypes = {
  onClose: PropTypes.func,
  noFixed: PropTypes.bool,
}

export default ImportantAlertView
